import { render, staticRenderFns } from "./ScreenDeadlines.vue?vue&type=template&id=0c204e3d"
import script from "./ScreenDeadlines.vue?vue&type=script&lang=js"
export * from "./ScreenDeadlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports